import { render, staticRenderFns } from "./Todolist.vue?vue&type=template&id=1833b2d6&scoped=true&"
import script from "./Todolist.vue?vue&type=script&lang=js&"
export * from "./Todolist.vue?vue&type=script&lang=js&"
import style0 from "./Todolist.vue?vue&type=style&index=0&id=1833b2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833b2d6",
  null
  
)

export default component.exports